import React from 'react'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

import serv1 from '../folder/images/mixed_services.png'

function Whyus() {
  const navigator = useNavigate()

  return (
    <div className="w-full h-full overflow-hidden">
        <div className='relative h-[40vh] md:min-h-[60vh] md:max-h-[60vh] relative bg-choose_us-bg bg-cover bg-no-repeat bg-center md:bg-right-top'>
          
          <div className='absolute  top-[6%] left-[10%]'>
          <h6 className='font_normal group text-white text-[13px] 2xl:text-[16px] flex items-center'><span onClick={()=>navigator('/')} className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Home</span> <FiChevronRight className='mx-2' />  <span className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Why Us</span>  </h6>  
          </div>
          <h1 className='text-white flex font_normal text-[13px] 2xl:text-[16px] p-6 bg-black px-10 md:text-[16px] absolute bottom-0 left-[10%] bg-opacity-70'><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#fff]'></span> We always look for customer satisfaction and his growth </h1>
        </div>

      <div className='max-w-[90%] mb-20 min-h-[60vh] mx-auto '>

        <h6 data-aos="fade-left"  className='font_bold text-[19px] 2xl:text-[22px] flex mt-10'>To choose us, we believe three aspects are important:</h6>

        <h6 data-aos="fade-right"  className='font_bold text-[16px] 2xl:text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Who are we?</h6>
        <h1 data-aos="fade-left"  className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Fidelitus Corp started as a commercial real estate firm and has grown into a versatile
company providing comprehensive solutions in real estate, facility management, project
execution, human resources, and specialized industry services.</h1>

        <h6 data-aos="fade-right"  className='font_bold text-[16px] 2xl:text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Our Competitive Edge</h6>
        <h1 data-aos="fade-left"  className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Our focus on the end-user experience, delivering seamless processes from strategic planning
to project completion, driven by our core principles of Safety, Efficiency, and Cost-
Effectiveness.</h1>

        <h6 data-aos="fade-right"  className='font_bold text-[16px] 2xl:text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Specialization Sets Us Apart</h6>
        <h1 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>At Fidelitus Corp, we are recognized as industry experts, known for our reliability and trust.
Our dedicated real estate transaction team carefully oversees every phase of a project, from
portfolio management to strategic planning and seamless execution. Our facility and property
management teams ensure safe, efficient, and cost-effective environments throughout
occupancy.
        </h1>
        
        <div className='md:flex items-center'>
          <div className='md:w-[50%]'>
          <h6 data-aos="fade-right" className='text-[14px] 2xl:text-[17px] font_bold mt-4'>A Complete Solution Under One Roof</h6>
          <h6 data-aos="fade-right" className='text-[14px] 2xl:text-[17px] font_normal mt-4'>Fidelitus Corp offers a full range of services, including:</h6>
          <ul data-aos="fade-left" className='ml-10 mt-5 list-disc'>
            <li className='text-[14px] 2xl:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>Transaction Services </span>: Site selection, transaction management, and portfolio handling.</li>
            <li className='text-[14px] 2x</span>l:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>Facility Management </span>: Efficient and cost-effective workspace solutions for
            continuous operations.</li>
            <li className='text-[14px] 2xl:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>Project Management and Interior Design </span>: Custom turnkey projects, from concept to timely, quality delivery</li>
            <li className='text-[14px] 2xl:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>HR Labs </span>: Tailored staffing and HR solutions for organizational success</li>
            <li className='text-[14px] 2xl:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>Fidelitus Gallery </span>: Showcasing creativity and culture through art exhibitions and
            events.</li>
            <li className='text-[14px] 2xl:text-[17px] font_normal mt-1 pl-6'><span className='font_bold'>Shilpa Foundation </span>: Leading environmentally conscious projects and community
            programs.</li>
          </ul>
          </div>

          <div className='md:w-[50%] h-[450px]  md:ml-[5%] mt-5 md:mt-12'>
            <img src={serv1} alt="fidelitus_service" className='w-[100%] h-[100%] object-contain' />
            
          </div>
       
        </div>

        <h6 data-aos="fade-right" className='text-[14px] 2xl:text-[17px] font_normal mt-4'>We provide integrated, end-to-end solutions to meet all your business needs under one roof.</h6>

        <h6 data-aos="fade-right" className='font_bold text-[16px] 2xl:text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Why Choose Us?</h6>
        <h6 data-aos="fade-left" className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Fidelitus Corp offers customized solutions, seamless execution, and a focus on safety, efficiency, and cost-effectiveness, making us the trusted partner for your growth and success.
 Images for real estate transactions in front page 
</h6>


      </div>


    </div>
  )
}

export default Whyus